"use client";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import Script from "next/script";
import { stripZeroWidth } from "@/utils/ContentfulHelper";

const HEYFLOW_EMBED_URL = "https://assets.prd.heyflow.com/builder/widget/latest/webview.js";

export interface Props {
  formId: string;
  anchorTag?: string;
  entryId?: string;
}

export function HeyflowFormView({ formId, anchorTag, entryId }: Props) {
  const cleanFormId = stripZeroWidth(formId).trim();
  const cleanAnchorTag = anchorTag ? stripZeroWidth(anchorTag) : undefined;
  const inspectorProps = useContentfulInspectorMode();
  const tag = entryId ? inspectorProps({ entryId, fieldId: "formId" }) : {};

  return (
    <div id={cleanAnchorTag} className="w-full p-6 max-w-site-content mx-auto" {...tag}>
      <Script src={HEYFLOW_EMBED_URL} strategy="afterInteractive" />
      <heyflow-wrapper key={cleanFormId} flow-id={cleanFormId} dynamic-height scroll-up-on-navigation />
    </div>
  );
}
